module.exports = __webpack_public_path__ + "img/002-Mujer.5261bd49.png";